export default "__VITE_ASSET__BuuCDjSH__"